import React from "react";
import "./Banner.css";

const Banner = () => {
  return (
    <div id="shop" className="mb-5">
      <div className="banner-area d-flex align-items-center">
        <div className="container ">
          <div className="row">
            <div className="col-md-7"></div>
            <div className="col-md-5">
            <h5 className="">WHAT WE'RE ABOUT</h5>
            <h1>SEE THE WORLD <br />DIFFERENTLY</h1>
            <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iusto, cum <br />Lorem ipsum dolor, sit amet consectetur adipisicing.</p>
            <button className="btn-area">SHOP NOW</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
